module.exports = __webpack_public_path__ + "img/platinum_product_img.338a852f.jpg";